<template>
  <div class="card__body-supplements" v-for="(supplement, index) in supplements" :key="index">
    <div class="card__supplements-row">
      <div class="card__supplements-title">{{ supplement.name }}</div>
      <div class="card__supplements-right">
<!--        <div class="card__supplements-number">{{ supplement.minQuantity }}/{{ supplement.maxQuantity }}</div>-->
        <div class="card__supplements-info">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 6.66667H10.0083M10 9.16667V13.3333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                stroke="#BBBCBF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="card__supplements-popup">
          <template v-if="supplement.required == 1">
            Необходимо выбрать от {{ supplement.minQuantity }} до {{ getMaxQuantity(supplement) }} добавок.
          </template>
          <template v-else>
            Можно выбрать от {{ supplement.minQuantity }} до {{ getMaxQuantity(supplement) }} добавок (необязательно).
          </template>
        </div>
      </div>
    </div>
    <AlertBox
      :is-show="errors?.['option']?.[supplement.product_option_id]"
      :message="errors?.['option']?.[supplement.product_option_id]"
    />
    <!-- <p style="color: red;margin-bottom: 16px; padding: 5px 10px; border-radius: 10px; background-color: rgba(255,0,0,0.17)" v-if="errors?.['option']?.[supplement.product_option_id]">{{ errors['option'][supplement.product_option_id] }}</p> -->
    <div class="card__supplements-list">
      <template v-for="supplementProduct in supplement.products">
      <label :for="'supplementProduct' + product.product_id + '-'+ supplementProduct.product_id"  class="card__supplements-input"  v-if="!supplementProduct.inSpotList"  >
          <input  @change="selectProduct(supplement.product_option_id, supplementProduct.product_id)"  :id="'supplementProduct' + product.product_id + '-'+  supplementProduct.product_id" type="checkbox" name="supplements">
          <div class="supplements__label">
            <div class="supplements__label-info">
              <div class="supplements__label-name">{{ supplementProduct.name }}</div>
              <div class="supplements__label-price">{{ supplementProduct.price ? supplementProduct.price : supplementProduct.price + '₽' }}</div>
            </div>
          </div>
      </label>
      </template>
    </div>
  </div>
</template>
<script>
import TheProductImage from "@/components/element/TheProductImage.vue";
import ProductImageType from "@/enum/ProductImageType.js";
import * as events from "events";
import AlertBox from "@/components/element/AlertBox.vue";

export default {
  name: 'TheProductSupplements',
  computed: {
    events() {
      return events
    },
    ProductImageType() {
      return ProductImageType
    }
  },
  components: {AlertBox, TheProductImage},
  data() {
    return {
      supplements: null,
      products: []
    }
  },
  created() {
    this.supplements = this.product.options.filter((option) => option.type === 'product');
    console.dir(this.supplements)
  },
  props: {
    product: {
      type: Object,
      require: true,
    },
    errors: {
      type: Object,
      require: true,
    },
    options: {
      type: Object,
      require: true,
    }
  },
  methods: {
    getMaxQuantity(supplement) {
      const count = (supplement.products || []).filter(p => !p.inSpotList).length
      return Math.min(Number(supplement.maxQuantity), count)
    },
    selectProduct(product_option_id, value){
      if(this.errors?.['option']?.[product_option_id]){
        this.errors['option'][product_option_id] = null
      }
      this.$emit('updateOption', product_option_id, [value], true)
    },
    isSizeSelected(product_option_value_id) {
      return this.options.some(option => Object.values(option).includes(product_option_value_id));
    }
  }
}
</script>

<style lang="scss" scoped>

</style>